import { render, staticRenderFns } from "./services_page.vue?vue&type=template&id=14c96b10&scoped=true&"
import script from "./services_page.vue?vue&type=script&lang=js&"
export * from "./services_page.vue?vue&type=script&lang=js&"
import style0 from "./services_page.vue?vue&type=style&index=0&id=14c96b10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c96b10",
  null
  
)

export default component.exports